import React from "react";
import { Offcanvas } from "react-bootstrap";
import {IMAGE_FETCH_BACKEND_URL} from "../../_config/site_urls";

interface Props {
    show: any;
    handleClose: any;
    helpData: any;
}

const HelpPanelRight = ({ show, handleClose, helpData }: Props) => {
    const helpText = helpData?.help_text || '';
    const title = helpData?.title || 'Help';

    const fixImageSrcPaths = (htmlString: any) => {
        if (!htmlString) return "";
        console.log(htmlString);
        // First replace resource placeholders
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        // Fix image src paths
        const images = doc.querySelectorAll("img");
        images.forEach((img) => {
            const src = img.getAttribute("src");
            if (src && src.startsWith("..")) {
                const cleanedSrc = src.replace(/^(\.\.\/)+/, "");
                img.setAttribute("src", `${IMAGE_FETCH_BACKEND_URL}/${cleanedSrc}`);
            }
        });
        let finalHtml = doc.body.innerHTML;

        finalHtml =  finalHtml.replace(/(<p>\s*);/g, '$1');

        return finalHtml;
    };
    return (
        <Offcanvas show={show} onHide={handleClose} placement={"end"} className="farming-method-offcanvas help-right-panel">
            <Offcanvas.Header className="aiAnsRightHeading" closeButton>
                <Offcanvas.Title>{title}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="row add-crop-block-wrapper">
                    <div className="mb-3 float-input w-100">
                        {/* <label className="form-label position-static">{title}</label> */}
                        <div 
                            className="form-control" 
                            style={{
                                minHeight: '400px',
                                maxHeight: '110vh',
                                overflowY: 'auto',
                                whiteSpace: 'pre-wrap',
                                wordWrap: 'break-word',
                                overflowWrap: 'break-word',
                                padding: '12px 15px',
                                lineHeight: '1.6',
                                fontSize: '14px',
                                backgroundColor: '#f9f9f9',
                                border: '1px solid #ddd',
                                borderRadius: '4px'
                            }}
                        >
                            <div dangerouslySetInnerHTML={{ __html: fixImageSrcPaths(helpText) || 'No help available.' }} />
                            {/* {helpText || 'No help available.'} */}
                        </div>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default HelpPanelRight;
